import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useLanguage } from "@/i18n/LanguageContext";

interface NewsPost {
  id: string;
  title: string;
  content: string;
  image_url: string | null;
  created_at: string;
}

export const useNewsPosts = () => {
  const { language } = useLanguage();
  const [posts, setPosts] = useState<NewsPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from("news_posts")
      .select("*")
      .eq("published", true)
      .order("created_at", { ascending: false })
      .limit(6)
      .then(({ data }) => {
        if (data) {
          setPosts(
            data.map((row) => ({
              id: row.id,
              title: row[`title_${language}` as keyof typeof row] as string || row.title_de,
              content: row[`content_${language}` as keyof typeof row] as string || row.content_de,
              image_url: row.image_url,
              created_at: row.created_at,
            }))
          );
        }
        setLoading(false);
      });
  }, [language]);

  return { posts, loading, hasPosts: posts.length > 0 };
};
